

























import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ReportReason } from "@scrile/api-provider/dist/api/ReportsProvider";
import { FormFields, FormValues } from "@/types";
import BaseCheckbox from "@/components/BaseCheckbox";

export default defineComponent({
  name: "ReportReasonsForm",
  components: { BaseCheckbox },
  props: {
    reasons: { type: Array as PropType<ReportReason[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const selectedReasonIds = ref<string[]>([]);
    const values = ref<FormValues>({});

    const selectedIds = computed(() => {
      return Object.entries(values.value)
        .filter(i => !!i[1])
        .map(i => i[0]);
    });

    const fields = computed<FormFields>(() => {
      return props.reasons.map(item => ({
        name: item.id,
        type: "checkbox",
        label: item.title,
        description: item.description,
      }));
    });

    const onCheckboxCheck = ({ status, reasonId }: { status: boolean; reasonId: string }) => {
      if (status) {
        selectedReasonIds.value.push(reasonId);
      } else {
        selectedReasonIds.value = selectedReasonIds.value.filter(i => i !== reasonId);
      }
    };

    const onInput = (field: string, value: boolean) => {
      values.value = {
        ...values.value,
        [field]: value,
      };
      emit("selectedIds", selectedIds.value);
    };

    return {
      fields,
      values,
      onCheckboxCheck,
      onInput,
    };
  },
});
